<template>
  <div ref="rootEl">
    <slot v-if="intersected" />
    <slot v-if="!intersected" name="placeholder" />
  </div>
</template>

<script lang="ts" setup>
const rootEl = ref<Element>();
const observer = ref<IntersectionObserver | null>(null);
const intersected = ref(false);

onMounted(() => {
  if (!rootEl.value) {
    return;
  }

  if ('IntersectionObserver' in window) {
    observer.value = new IntersectionObserver(([firstEntry]) => {
      intersected.value = firstEntry?.isIntersecting ?? false;

      // should only initialize once, disconnect after first intersection
      if (intersected.value) {
        observer.value?.disconnect();
      }
    });

    observer.value.observe(rootEl.value);
  } else {
    // XXX: automatically poly-filled by babel?
    intersected.value = true;
  }
});

onUnmounted(() => {
  observer.value?.disconnect();
  observer.value = null;
});
</script>
